import React from "react";
import styled from "styled-components";
import { equals, sort } from "ramda";
import { Formik } from "components/generic/form/formik";
import { Button } from "components/generic/kit";
import close from "components/assets/close.svg";
import Checkbox from "./Checkbox";

export default ({ selected, field, items, title, onClose, onSubmit }) => {
  const initialValues =
    selected && selected.reduce((acc, key) => ({ ...acc, [key]: true }), {});

  return (
    <div
      onClick={onClose}
      className="fixed top-0 left-0 w-100 h-100 bg-black-40 flex items-center justify-center z-max"
    >
      <Body onClick={e => e.stopPropagation()}>
        <Title>
          {title}
          <div onClick={onClose} className="ml-auto w2 pointer">
            <img src={close} alt="" />
          </div>
        </Title>
        <Formik
          initialValues={initialValues}
          onSubmit={data => {
            onSubmit(
              field,
              Object.keys(data).reduce(
                (acc, k) => (!data[k] ? acc : [...acc, k]),
                []
              ),
              data
            );
            onClose();
          }}
        >
          {props => (
            <FormWrap {...props} initialValues={initialValues} items={items} />
          )}
        </Formik>
      </Body>
    </div>
  );
};

class FormWrap extends React.Component {
  componentDidMount() {
    const { initialValues, items } = this.props;

    if (initialValues) {
      const categories = items.map(item => Object.keys(item)[0]);

      for (let category of categories) {
        const companies = items.find(item => Object.keys(item)[0] === category)[
          category
        ];

        const current = initialValues[category];

        /**
         * When category checkbox enabled - checking all it's companies.
         */
        if (current) {
          this.props.setValues({
            ...initialValues,
            ...companies.reduce((acc, c) => ({ ...acc, [c]: true }), {})
          });
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!equals(nextProps.values, this.props.values)) {
      const categories = nextProps.items.map(item => Object.keys(item)[0]);
      const { values, setValues } = nextProps;

      for (let category of categories) {
        const companies = nextProps.items.find(
          item => Object.keys(item)[0] === category
        )[category];
        const update = checked =>
          setValues({
            ...values,
            ...companies.reduce((acc, c) => ({ ...acc, [c]: checked }), {})
          });

        const current = values[category];
        const prev = this.props.values[category];

        /**
         * When category checkbox enabled - checking all it's companies.
         */
        if (current && !prev) {
          update(true);
          /**
           * When category checkbox disabled - unchecking all it's companies.
           */
        } else if (prev && !current && companies.every(c => values[c])) {
          update(false);
          /**
           * When some company checkbox disabled - unchecking it's parent category.
           */
        } else if (prev && companies.some(c => !values[c])) {
          setValues({
            ...values,
            [category]: false
          });
        }
      }
    }
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Items>
          {this.props.items.map((item, i) => (
            <div key={i} className="mb2">
              <label className="db pointer fw6 f3 mb2">
                <Checkbox name={Object.keys(item)[0]} />
                <span className="ml2">{Object.keys(item)[0]}</span>
              </label>
              <div className="pl4 flex flex-wrap">
                {Object.values(item)[0].map((c, i) => (
                  <label key={i} className="db pointer w-25 f6 mb2">
                    <Checkbox name={c} />
                    <span className="ml1">{c}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </Items>
        <Button color="white">Choose</Button>
      </form>
    );
  }
}

const Body = styled.div`
  background-color: #f9f7f2;
  border-top: 8px solid #000;
  padding: 30px 50px;
  max-width: 1150px;
  width: 100%;
  height: 93%;
  overflow-y: auto;
`;

const Title = styled.div`
  font-family: TiemposHeadlineWeb;
  font-weight: 400;
  font-size: 2rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
`;

const Items = styled.div`
  font-family: CircularStd-Book;
  margin-bottom: 1rem;
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/InsidersList/internal/Modal/index.js